<template>
  <a-row :gutter="16">
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-select v-model:value="queryForm.orgid" :options="qorgs" :filter-option="$filters.filterOption" show-search
        style="width:100%;">
      </a-select>
    </a-col>
    <a-col :xxl="6" :xl="8" :lg="8" :md="12">
      <a-input v-model:value="queryForm.number" placeholder="供应商名称" style="width:100%;" />
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-button type="primary" @click="getData">查询</a-button>
    </a-col>
  </a-row>
  <div class="d-flex justify-space-between align-center mb-2 mt-2">
    <a-space>
      <a-button type="danger" @click="add">
        <template #icon>
          <PlusOutlined />
        </template>
        新增供应商
      </a-button>
      <a-button type="link" @click="getData">刷新数据</a-button>
    </a-space>
    <a-dropdown>
      <template #overlay>
        <a-menu>
          <a-menu-item @click="exportselected" :disabled="selectedRowKeys.length === 0">导出勾选</a-menu-item>
          <a-menu-item @click="exportall">导出所有页</a-menu-item>
          <a-menu-item @click="exporttask" class="text-error">查看导出任务</a-menu-item>
        </a-menu>
      </template>
      <a-button type="primary">
        导出数据
        <DownOutlined />
      </a-button>
    </a-dropdown>
  </div>
  <a-table :columns="columns" bordered :data-source="data" :loading="dataLoading" :scroll="{ x: width, y: 600 }"
    :pagination="{
      current: page,
      pageSize: limit,
      total: count,
      showQuickJumper: true,
      showSizeChanger: true,
    }" @change="(pagination) => {
      page = pagination.current;
      limit = pagination.pageSize;
    }" row-key="_id" :row-selection="{
      selectedRowKeys,
      onChange: (keys) => selectedRowKeys = keys
    }">
    <template #bodyCell="{ record, column }">
      <template v-if="column.dataIndex === 'org'">
        {{ getorgname(record.orgid) }}
      </template>
      <template v-if="column.dataIndex === 'operation'">
        <a-button type="link" @click="edit(record)"> 编辑 </a-button>
      </template>
    </template>
  </a-table>
  <a-modal v-model:visible="supplierModal" :title="supplierTitle" @ok="save" @cancel="cancelSave" ok-text="确认"
    cancel-text="取消" :confirm-loading="saving" :cancel-button-props="{ disabled: saving }" :maskClosable="false"
    :closable="!saving">
    <a-form ref="formRef" name="supplierForm" :model="supplierForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"
      autocomplete="off">
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-item label="商户" name="orgid" :rules="[{ required: true, message: '请选择商户' }]">
            <a-select v-model:value="supplierForm.orgid" :options="sorgs" :filter-option="$filters.filterOption"
              placeholder="请选择" :disabled="saving || supplierForm._id !== ''" show-search style="width:100%;">
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="供应商全称" name="name" :rules="[{ required: true, message: '请输入供应商名称' }]">
            <a-input v-model:value="supplierForm.name" placeholder="供应商名称" :disabled="saving">
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="供应商简称" name="name">
            <a-input v-model:value="supplierForm.shortname" placeholder="供应商简称" :disabled="saving">
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="联系人" name="linkman">
            <a-input v-model:value="supplierForm.linkman" placeholder="联系人" :disabled="saving">
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="联系电话" name="linkphone">
            <a-input v-model:value="supplierForm.linkphone" placeholder="联系电话" :disabled="saving">
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="地址" name="address">
            <a-textarea v-model:value="supplierForm.address" placeholder="地址" :rows="2" :disabled="saving">
            </a-textarea>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="开户行" name="bankname">
            <a-input v-model:value="supplierForm.bankname" placeholder="开户行" :disabled="saving">
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="银行账号" name="bankaccount">
            <a-input v-model:value="supplierForm.bankaccount" placeholder="银行账号" :disabled="saving">
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="备注" name="remark">
            <a-input v-model:value="supplierForm.remark" placeholder="备注" :disabled="saving">
            </a-input>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>
<script setup>
import { DownOutlined, PlusOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import { ref, watch, computed, onMounted, getCurrentInstance, } from "vue";
import _ from "underscore";
const columns = [
  { title: '商户名称', dataIndex: 'org', width: 100 },
  { title: '供应商全称', dataIndex: 'name', width: 200 },
  { title: '供应商简称', dataIndex: 'shortname', width: 120 },
  { title: '开户行', dataIndex: 'bankname', width: 200, },
  { title: '银行账号', dataIndex: 'bankaccount', width: 180, },
  { title: '联系人', dataIndex: 'linkman', width: 100 },
  { title: '联系电话', dataIndex: 'linkphone', width: 120, },
  { title: '地址', dataIndex: 'address', width: 150, },
  { title: '备注', dataIndex: 'remark', width: 150, },
  { title: '创建时间', dataIndex: 'create_time', width: 120, },
  { title: '操作', dataIndex: 'operation', width: 100, fixed: 'right' }
];
const { proxy } = getCurrentInstance();
const formRef = ref();

const queryForm = ref({
  orgid: "ALL",
  name: "",
});
const dataLoading = ref(false);
const page = ref(1);
const limit = ref(20);
const length = ref(0);
const count = ref(0);
const data = ref([]);
const selectedRowKeys = ref([]);
const supplierTitle = ref('');
const supplierForm = ref({});
const supplierModal = ref(false);
const saving = ref(false);
const orgs = ref([]);

const sorgs = computed(() => _.map(orgs.value, n => ({ value: n._id, label: n.name })));
const qorgs = computed(() => {
  return [
    { value: 'ALL', label: '全部商户' },
    ...sorgs.value,
  ]
});
const width = computed(() => proxy.$utils.twidth(columns));

watch(() => page.value, () => {
  getData();
});
watch(() => limit.value, () => {
  if (page.value !== 1) page.value = 1;
  else getData();
});

onMounted(() => {
  getData();
});

const getData = () => {
  dataLoading.value = true;
  proxy.$api.doAPI("/supplier/list", { page: page.value, limit: limit.value, ...queryForm.value }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      data.value = _.map(res.data.list, n => {
        return {
          ...n,
          create_time: proxy.$dateFormat(n.create_time, 'YYYY-MM-DD HH:mm'),
        }
      });
      length.value = res.data.length;
      count.value = res.data.count;
      if (length.value > 0 && page.value > length.value) page.value = 1;
      orgs.value = res.data.orgs;
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
};
const initForm = () => {
  return {
    _id: "", orgid: null,
    name: "", shortname: "",
    linkman: "", linkphone: "", address: "",
    bankname: "", bankaccount: "",
    remark: "",
  };
};
const add = () => {
  supplierTitle.value = "新增供应商";
  supplierForm.value = initForm();
  supplierModal.value = true;
};
const edit = (item) => {
  supplierTitle.value = "编辑供应商";
  supplierForm.value = _.pick(item, _.keys(initForm()));
  supplierModal.value = true;
}
const save = async () => {
  try {
    await formRef.value.validateFields();
    saving.value = true;
    proxy.$api.doAPI("/supplier/save", { dataForm: supplierForm.value }).then((res) => {
      saving.value = false;
      if (res.code === 0) {
        supplierModal.value = false;
        getData();
      } else {
        message.error(res.msg);
      }
    }).catch((err) => {
      saving.value = false;
      console.error(err);
    });
  } catch (errorInfo) {
    console.log("Failed:", errorInfo);
  }
};
const cancelSave = () => {

};
const getorgname = (value) => {
  return _.findWhere(orgs.value, { _id: value })?.name || '-';
}
const exportselected = () => {
}
const exportall = () => {
}
const exporttask = () => {

}
</script>
<style lang="less" scoped>
:deep(.ant-layout-header) {
  display: flex;
  padding: 0 20px;
}

:deep(.ant-table-thead > tr > th) {
  padding: 8px 8px !important;
}

p {
  margin: 0;
  padding: 0;
}

.static {
  padding: 20px;
  background-color: #f2f2f2;
  margin-bottom: 10px;
}
</style>